import styled from "styled-components";

import { Container } from "components/ui";

import { media } from "constants/media";

export const Wrapper = styled.div`
    min-height: 494px;
    padding-top: 48px;
    position: relative;
`;

export const StyledContainer = styled(Container)`
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    grid-gap: 0;
    position: relative;

    ${media.mdUp} {
        display: grid;
        grid-gap: 16px 0;
    }
`;

export const Left = styled.div`
    margin-bottom: 48px;
    max-width: 580px;
    width: 100%;
`;

export const Title = styled.h1`
    font-size: 40px;
    font-weight: normal;
    line-height: 56px;

    ${media.mdUp} {
        font-size: 56px;
        line-height: 80px;
    }
`;

export const Description = styled.h5`
    font-size: 20px;
    font-weight: normal;
    margin-top: 8px;
`;

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 24px 0;
    width: 100%;

    ${media.mdUp} {
        align-items: center;
        flex-direction: row;

        > label {
            width: 100%;
        }

        > div {
            margin-top: 30px;
            min-width: 160px;
        }
    }
`;

export const ImageWrapper = styled.div`
    margin-bottom: 24px;
    position: relative;
    width: 100%;
    z-index: -1;

    ${media.lgUp} {
        bottom: 0;
        height: 100%;
        margin-bottom: 0;
        max-height: 494px;
        max-width: 698px;
        position: absolute;
        right: 0;
        width: 100vh;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
